import { Base } from '@studiometa/js-toolkit';
import Accordion from './Accordion/index.js';

/**
 *  component
 */
export default class AccordionSkeepers extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'AccordionSkeepers',
    components: {
      Accordion,
    },
  };

  /**
   *
   */
  mounted() {
    this.skeepersWidget = this.$el.querySelector('.skeepers_product__reviews');
    const hasContent = this.skeepersWidget && this.skeepersWidget.children.length > 0;

    if (hasContent) {
      this.$el.classList.remove('hidden');
      this.setupScrollHandler();
    }
  }

  /**
   *
   */
  setupScrollHandler() {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href="#skeepers_product_widget"]');

      if (link) {
        event.preventDefault();
        this.scrollToAndOpen();
      }
    });
  }

  /**
   *
   */
  scrollToAndOpen() {
    const sectionTop = this.$el.getBoundingClientRect().top + window.pageYOffset;
    const offset = 80;
    const scrollTarget = sectionTop - offset;

    window.scrollTo({
      top: scrollTarget,
      behavior: 'smooth',
    });

    setTimeout(() => {
      this.$children.Accordion[0].$children.AccordionItem[0].open();
    }, 500);
  }
}
